import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';

import MobileComponent from './MobileComponent';
import DekstopComponent from './DekstopComponent';
import { showModal } from '../../../../actions/modal';

import Adaptive from '../../../common/Adaptive';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

const TableWrap = styled('div')`
  .table-row {
    padding: 16px;
    margin: 0 -16px;
    background: white;
    border-top: 1px solid #e3e5e7;
    border-bottom: 1px solid #e3e5e7;
    display: flex;
    justify-content: space-between;
    .editable {
      display: inline-flex;
      margin: 0 5px;
    }

    .table-item-title {
      font-weight: 600;
      margin-bottom: 5px;
    }
    .table-item-art,
    .table-item-id {
      font-size: 11px;
    }
    .table-item-id {
      margin-bottom: 5px;
    }
    .item-remove {
      width: 20px;
      height: 20px;
      flex: none;
      margin-left: 10px;
    }
    .img {
      width: 50px;
      height: 50px;
      margin-right: 16px;
      flex: none;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .right {
      display: flex;
    }
  }
`;

const Wrapper = styled('div')`
  .image-td {
    width: 35px;
    padding-right: 5px !important;
    padding-left: 5px !important;
    .image-block {
      width: 45px !important;
      height: 45px !important;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
  }

  .red {
    color: #ff95a4;
    font-size: 12px;
    line-height: 12px;
  }

  .table-item {
    .editable {
      min-width: 90px;
    }
  }

  .item-name {
    font-weight: 700;
    color: #343a40;
  }

  .item-article {
    font-size: 10px;
    color: #72747b;
  }

  .item-subname {
    font-size: 10px;
    color: #98a6ad;
  }

  .shortname-td {
    max-width: 300px;
    min-width: 150px;
    .ids-span {
      font-size: 11px;
      color: #98a6ad;
      cursor: pointer;
      font-weight: normal;
    }
  }
`;

const VirtualSetBlock = (props) => {
  const {
    currentProduct,
    currentVirtualSets = currentProduct ? currentProduct.variants : null,
    data,
    needAdditionalData,
    handleUpdateSkuSet,
    isNew,
    openItem,
  } = props;

  const dispatch = useDispatch();
  const history = useHistory();

  const allowVariativeBundles = useSelector((state) => state.auth.account?.allowVariativeBundles);

  const [loading, setLoading] = useState(false);
  const [requiredQuantity, setRequiredQuantity] = useState(0);

  const [currentQuantityInput, setCurrentQuantityInput] = useState(null);
  const [currentQuantityInputValue, setCurrentQuantityInputValue] = useState(null);

  const updateData = (items, count) => {
    const newItems = items.map((p) => {
      const isNewAddItem = !p['productId'];
      if (isNewAddItem) {
        let item = data?.[0].items.find((i) => i.variantId === p.variantId);
        return {
          id: p.variantId || p.id,
          quantity: p.quantity,
          optional: item ? item.optional : false,
        };
      } else {
        let item = data?.[0].items.find((i) => i.variantId === p.variantId);
        return {
          id: p.variantId || p.id,
          quantity: p.quantity,
          optional: p.optional,
        };
      }
    });

    return handleUpdateSkuSet(needAdditionalData ? items : newItems, count);
  };

  const handleNewItem = () => {
    dispatch(
      showModal('SkuSetAddingProducts', {
        needVariants: true,
        type: 'BUNDLE',
        bundleOptionalCount: 0,
        currentProducts:
          data?.[0].items?.map((p) => ({
            variantId: p.id || p.variantId,
            quantity: p.quantity,
            optional: p.optional,
          })) ?? [],
        submitCallback: updateData,
      }),
    );
  };

  const handleRemoveItem = async (itemData, itemIndex) => {
    setLoading(true);
    const newSet = data[0].items.slice();

    newSet.splice(itemIndex, 1);

    const newRequiredQuantity = newSet.reduce((acc, item) => {
      return acc + +!item.optional;
    }, 0);

    if (!newRequiredQuantity && newSet.length) {
      newSet[0].optional = false;
    }

    await updateData(newSet, data[0].bundleOptionalCount).finally(() => {
      setLoading(false);
    });
  };

  const handleUpdateQuantity = async (value, itemIndex) => {
    const newSet = data[0].items.slice();
    newSet[itemIndex].quantity = value;
    await updateData(newSet, data[0].bundleOptionalCount).finally(() => {
      setCurrentQuantityInput(null);
    });
  };
  const handleUpdateOptional = async (value, itemIndex) => {
    const oldSet = data[0].items.slice();
    const newSet = data[0].items.slice();

    const oldRequiredQuantity = newSet.reduce((acc, item) => {
      return acc + +!item.optional;
    }, 0);

    if (!oldRequiredQuantity) {
      toast.error('Должен быть хотя бы один обязательный товар');
      await updateData(newSet, data[0].bundleOptionalCount);
      return false;
    }
    newSet[itemIndex].optional = !value;
    const newRequiredQuantity = newSet.reduce((acc, item) => {
      return acc + +!item.optional;
    }, 0);

    if (!newRequiredQuantity) {
      oldSet[itemIndex].optional = false;
      toast.error('Должен быть хотя бы один обязательный товар');
      await updateData(oldSet, data[0].bundleOptionalCount);
      return false;
    }

    if (allowVariativeBundles && newRequiredQuantity === newSet.length) {
      await updateData(newSet, 0);
    } else {
      await updateData(newSet, data[0].bundleOptionalCount);
    }
  };

  const handleToggleQuantityInput = ({ variantId, quantity }) => {
    setCurrentQuantityInput(variantId);
    setCurrentQuantityInputValue(quantity);
  };

  const handleUpdateBundleOptionalCount = async (value) => {
    if (allowVariativeBundles && value < requiredQuantity) {
      toast.error(
        'Количество товаров в наборе не должно быть меньше количества обязательных товаров',
      );
      return false;
    }

    const newSet = data[0].items.slice();
    await updateData(newSet, value - requiredQuantity);
  };

  useEffect(() => {
    if (data && data?.[0]?.items.length) {
      setRequiredQuantity(
        data[0].items.reduce((acc, item) => {
          return acc + +!item.optional;
        }, 0),
      );
    }
  }, [data]);

  const adaptiveProps = {
    Wrapper,
    TableWrap,
    data: data && data[0],
    loading,
    handleNewItem,
    handleRemoveItem,
    currentVirtualSets,
    currentQuantityInput,
    currentQuantityInputValue,
    handleToggleQuantityInput,
    handleUpdateQuantity,
    setCurrentQuantityInputValue,
    setCurrentQuantityInput,
    handleUpdateOptional,
    handleUpdateBundleOptionalCount,
    openItem,
    allowVariativeBundles,
    isNew,
    requiredQuantity,
  };

  return (
    <Adaptive
      DekstopComponent={DekstopComponent}
      MobileComponent={MobileComponent}
      adaptiveProps={adaptiveProps}
    />
  );
};

export default VirtualSetBlock;
